import { faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faBlenderPhone, faEnvelope, faGlobe, faMap, faMobileAlt, faPhone } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import { Link } from 'react-router-dom'
import {FooterContainer} from '../../styles/Header'
import logo from "../../mainlogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
export default function Footer() {
  return (
    <FooterContainer>
      <div className="copyright">
        <div className="logos">
          <img src={logo} alt="logo" />
        </div>
        <div className="main">
          <div onClick={() => window.open("tel:+902125161970")}>
            <FontAwesomeIcon icon={faPhone} /> +90 212 516 19 70
          </div>
          <div onClick={() => window.open("tel:+9054609000102")}>
            <FontAwesomeIcon icon={faMobileAlt} /> +90 546 900 01 02
          </div>
          <div onClick={() => window.open("tel:+905380922264")}>
            <FontAwesomeIcon icon={faMobileAlt} /> +90 538 092 22 64
          </div>
          {/* <div onClick={() => window.open("mailto:info@ulusoyspor.com")}>
            <FontAwesomeIcon icon={faEnvelope} /> info@ulusoyspor.com
          </div> */}
        </div>
        <div
          onClick={() =>
            window.open(
              "https://www.google.com/maps/place/Ulusoy+Spor/@41.0075099,28.9634691,17z/data=!3m1!4b1!4m6!3m5!1s0x14cab0915de3ee5f:0x86f59b0a78cd1259!8m2!3d41.00751!4d28.9683454!16s%2Fg%2F11c6cww8z4?entry=ttu"
            )
          }
          style={{
            marginTop: 10,
            marginBottom: 10,
            fontSize: 15,
            cursor: "pointer",
          }}
        >
          Mimar Hayrettin Mah. Gedikpaşa cami sok. <br /> No : 16{" "}
          <strong>Fatih/İstanbul</strong>
        </div>
        {/* <div> Tüm hakları sakldırı &copy; 2023</div> */}
        <div>
          <img
            src="https://dehasoft.com.tr/dehasoftblack.png"
            className="dehasoft-img"
            onClick={() => window.open("https://dehasoft.com.tr/", "_blank")}
          />
        </div>
      </div>
    </FooterContainer>
  );
}
